import { z } from 'zod';
import { alertStatus, isoTimestamp, labels, pageQuery, severity, uuid, } from './primitives.js';
export const alert = z.object({
    id: uuid,
    source_id: uuid,
    source_key: z.string(),
    source_name: z.string(),
    fingerprint: z.string(),
    dedup_key: z.string().nullable(),
    title: z.string(),
    body: z.string().nullable(),
    severity,
    status: alertStatus,
    labels,
    url: z.url().nullable(),
    occurrences: z.number().int(),
    first_seen_at: isoTimestamp,
    last_seen_at: isoTimestamp,
    acknowledged_at: isoTimestamp.nullable(),
    acknowledged_by: uuid.nullable(),
    acknowledged_by_name: z.string().nullable(),
    resolved_at: isoTimestamp.nullable(),
    delivery_summary: z.object({
        pending: z.number().int(),
        delivered: z.number().int(),
        failed: z.number().int(),
        dead: z.number().int(),
    }),
});
/**
 * Generic ingest payload. Alertmanager and Grafana payloads are normalised
 * into this shape server-side before validation of the normalised result.
 */
export const ingestAlertBody = z.object({
    title: z.string().min(1).max(300),
    body: z.string().max(8000).nullish(),
    severity: severity.optional(),
    /** Only `firing` and `resolved` may be set by a source. */
    status: z.enum(['firing', 'resolved']).default('firing'),
    /** Stable identity of the underlying condition. Repeats update, not duplicate. */
    dedup_key: z.string().min(1).max(200).nullish(),
    labels: labels.default({}),
    url: z.url().max(2000).nullish(),
    occurred_at: isoTimestamp.optional(),
});
/**
 * One result per alert in the request. Generic sources send a single alert,
 * Alertmanager and Grafana batch a whole group, so the response is always a
 * list rather than two different shapes.
 */
export const ingestResult = z.object({
    alert_id: uuid,
    deduplicated: z.boolean(),
    /** How many deliveries the routing engine enqueued for this event. */
    deliveries_enqueued: z.number().int(),
});
export const ingestAlertResponse = z.object({
    accepted: z.number().int(),
    results: z.array(ingestResult),
});
export const listAlertsQuery = pageQuery.extend({
    status: alertStatus.optional(),
    severity: severity.optional(),
    source_id: uuid.optional(),
    q: z.string().min(1).max(200).optional(),
});
//# sourceMappingURL=alerts.js.map